import { FetchResponseType, performFetch } from '../getApiUrl';

export type AllToggles = {
	 name: string; status: boolean
}
type GetAllTogglesResponse = {
	data: AllToggles[]
}

export class UnleashController {
	public static async getAllToggles(): Promise<FetchResponseType<AllToggles[]>> {
		const response =  await performFetch<GetAllTogglesResponse>({
			method: 'GET',
			endpoint: 'getUnleashToggles'
		});
		return {
			statusCode: response.statusCode,
			data: response.data?.data
		};
	}
}